import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import HelenAPI from "@helen/sdk";
import AppDialog from "./AppDialog";

const styles = theme => ({
  settingFormControl: {
    marginTop: "10%",
    width: "100%",
    maxWidth: 360,
    marginLeft: "auto",
    marginRight: "auto"
  },
  margin: {
    marginTop: theme.spacing.unit,
    width: "100%"
  },
  button: {
    marginTop: 15,
    color: "#009688",
    float: "right"
  },
  linkStyle: {
    textDecoration: "none"
  },
  cssLabel: {
    "&$cssFocused": {
      color: "#009688"
    }
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: "#009688"
    }
  }
});

class SignIn extends React.Component {
  state = {
    username: "",
    password: "",
    succeeded: false,
    invalidUsername: false,
    invalidPassword: false,
    showErrorModal: false,
    loading: false
  };

  // Validating username and password
  validateSignin = async () => {
    this.setState({ loading: true });
    const { username, password } = this.state;
    if (!username) {
      this.setState({ invalidUsername: true, loading: false });
      return;
    }
    if (!password) {
      this.setState({ invalidPassword: true, loading: false });
      return;
    }
    try {
      const { user } = await HelenAPI.signin(username, password);
      if (user) {
        const validUser =
          user.claims.languages >= 1 && user.claims.phrases >= 3;
        if (validUser) {
          this.setState({ succeeded: true });
        } else {
          this.setState({ showErrorModal: true, loading: false });
        }
      }
    } catch (error) {
      this.setState({ showErrorModal: true, loading: false });
    }
  };

  // Rendering elements in signin screen
  render = () => {
    const { classes } = this.props;
    if (this.state.succeeded) {
      return <Redirect to="/select-language" />;
    }
    return (
      <div className={classes.settingFormControl}>
        <Typography variant="title" gutterBottom>
          Sign in
        </Typography>
        <Typography variant="body2" gutterBottom>
          Enter your Username and Password
        </Typography>
        <form noValidate autoComplete="off">
          <FormControl
            className={classes.margin}
            error={this.state.invalidUsername}
          >
            <InputLabel
              FormLabelClasses={{
                root: classes.cssLabel,
                focused: classes.cssFocused
              }}
              htmlFor="username-input"
            >
              Username
            </InputLabel>
            <Input
              classes={{
                underline: classes.cssUnderline
              }}
              id="username-input"
              value={this.state.username}
              onChange={({ target: { value } }) => {
                this.setState({ username: value, invalidUsername: false });
              }}
            />
          </FormControl>
          <br />
          <FormControl
            className={classes.margin}
            error={this.state.invalidPassword}
          >
            <InputLabel
              FormLabelClasses={{
                root: classes.cssLabel,
                focused: classes.cssFocused
              }}
              htmlFor="password-input"
            >
              Password
            </InputLabel>
            <Input
              type="password"
              autoComplete="current-password"
              classes={{
                underline: classes.cssUnderline
              }}
              id="password-input"
              value={this.state.password}
              onChange={({ target: { value } }) => {
                this.setState({ password: value, invalidUsername: false });
              }}
            />
          </FormControl>
          <br />
          <Button
            variant="raised"
            className={classes.button}
            onClick={this.validateSignin}
            disabled={this.state.loading}
          >
            NEXT
          </Button>
          {this.state.loading && (
            <CircularProgress
              className={classes.progress}
              style={{ color: "#004D40", marginLeft: "65%", marginTop: "6%" }}
              size={24}
            />
          )}
          <br />
          <AppDialog
            open={this.state.showErrorModal}
            onClose={() => this.setState({ showErrorModal: false })}
            text="User lacks permission to use HRI for this instance of Helen."
            title="Permission Denied"
          />
        </form>
      </div>
    );
  };
}
SignIn.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SignIn);



// WEBPACK FOOTER //
// ./src/components/SignIn.jsx